import { PropsWithChildren } from 'react'

const ItemCount = ({ children }: PropsWithChildren<{}>) => (
  <div className="rounded-full border border-solid border-text-primary/30 px-2.5 py-0.5 text-xs">
    <b className="text-brand-primary">{children}</b>
  </div>
)

export default ItemCount
